import { getApiQuery } from "./urlQueryService";
import getApiEndpoint from "./apiEndpoint";

const apiEndpoint = `${getApiEndpoint()}/order`;

export function billingHistoryUrl(query?: string) {
  return `${apiEndpoint}?${getApiQuery(query)}`;
}
